import React, { Component } from 'react'
import { observer, PropTypes } from 'mobx-react'

import { Col, Row } from 'react-bootstrap'

import DataClassFilter from '../../components/DataClassFilter'
import SpeciesFilter from '../../components/SpeciesFilter'

@observer
class SideBar extends Component {
  render() {
    return (
      <Row>
        <Col xs={12} style={{ marginTop: '10px' }}>
          <SpeciesFilter store={this.props.store} />
          <DataClassFilter store={this.props.store} />
        </Col>
      </Row>
    )
  }
}

SideBar.propTypes = {
  store: PropTypes.observableObject.isRequired,
}

export default SideBar
